import React from "react";
import { Mt5MenuIcon } from "./Mt5MenuIcons";
import useAppLanguage from "hooks/useAppLanguage";

/** Mobile Settings → Reports list (each row opens a report page). */
export default function ReportsMenuPage({ items = [], onSelect }) {
  const { t } = useAppLanguage();
  return (
    <div className="fx-color-templates-page fx-reports-menu-page">
      <ul className="fx-color-templates-list" role="list" aria-label={t("reports")}>
        {items.map((item) => (
          <li key={item.id || item.page}>
            <button
              type="button"
              className="fx-color-templates-row fx-reports-menu-row"
              onClick={() => onSelect?.(item.page)}
            >
              <span className="fx-color-templates-row__icon">
                <Mt5MenuIcon id={item.iconId || "reports"} />
              </span>
              <span className="fx-color-templates-row__label">
                {item.labelKey ? t(item.labelKey) : item.label}
              </span>
              <span className="fx-reports-menu-row__arrow" aria-hidden />
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
